// extracted by mini-css-extract-plugin
export default {"card":"problem-card_card__WJJWq","card__text":"problem-card_card__text__gUc08","card__icon":"problem-card_card__icon__+qK7F"};